<template lang="html">
  <modal ref="modal" size="fluid" title="Draft picks">
    <div v-for="(pick, i) in picks" :key="i">
      <div class="round" v-if="i % draft.teams.length === 0">
        ROUND {{ Math.ceil((i + 1) / draft.teams.length) }}
      </div>

      <div class="pick">
        <span>
          {{ i + 1 }}.
        </span>

        <span v-if="pick.player">
          {{ pick.player.position }}
          {{ pick.player.name }}
          <span class="keeper-status" v-if="pick.keeper">K</span>
          ({{ pick.team }})
        </span>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
    }),

    ...mapGetters({
      picks: 'draft/picks',
    }),
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .round {
    font-weight: bold;
    font-size: 20px;
    margin: $gp 0;
  }
</style>
